import axios from 'axios';
import { apiPaths } from 'constants/path';
import { apiKeyHeader, tokenHeader } from 'functions/apiFunctions';
import { GetVoucherListApiListType, GetVoucherListApiType } from 'models/Admin/AdminVoucherPageTypes';

class AdminManageVoucherPageApi {
    async getVoucherList(page: number | null, type: number | null, status: number | null, token: string): Promise<GetVoucherListApiType> {
        let url = `${apiPaths.getVoucherList}?page=${page}&limit=11`;
        if (type !== null && type !== undefined) {
            url += `&type=${type}`;
        }
        if (status !== null && status !== undefined) {
            url += `&status=${status}`;
        }

        try {
            const resopnse = await axios.get(url, { headers: tokenHeader(token) });
            return resopnse.data;
        } catch (error) {
            throw error;
        }
    }

    async sendVoucherMessage(code: string, mobile: string, name: string, description: string, token: string): Promise<GetVoucherListApiListType> {
        try {
            const response = await axios.post(`${apiPaths.sendVoucherMessage}`, { code, mobile, name, description }, { headers: tokenHeader(token) });
            return response.data.data;
        } catch (error) {
            throw error;
        }
    }

    async createVoucherCode(type: number, count: number, token: string): Promise<GetVoucherListApiListType> {
        try {
            const response = await axios.post(`${apiPaths.createVoucherCode}`, { type, count }, { headers: apiKeyHeader(token) });
            return response.data.data;
        } catch (error) {
            throw error;
        }
    }
}

export const adminManageVoucherPageApi = new AdminManageVoucherPageApi();
